<template>
  <nav class="navbar bg-base-100 shadow flex flex-col relative">
    <div class="container mx-auto flex justify-between items-center px-4">
      <NuxtLink to="/" class="text-xl font-bold text-primary">
        <img src="/logo.png" alt="Logo de Soleando" class="h-12" />
      </NuxtLink>
      <div class="flex gap-4 items-center">
        <NuxtLink
          to="/trips/customize"
          class="btn btn-ghost hidden md:inline-flex"
          >Personalizar viaje</NuxtLink
        >
        <NuxtLink to="/blog" class="btn btn-ghost hidden md:inline-flex"
          >Blog</NuxtLink
        >
        <template v-if="user">
          <button class="btn btn-error btn-sm" @click="logout">
            Cerrar sesión
          </button>
        </template>
        <template v-else>
          <NuxtLink to="/login" class="btn btn-primary"
            >Iniciar sesión</NuxtLink
          >
        </template>
      </div>
    </div>
    <div class="border-t border-t-base-content/10 w-full my-2 md:hidden"></div>
    <div
      class="container mx-auto flex justify-between items-center px-4 md:hidden"
    >
      <NuxtLink to="/blog" class="btn btn-ghost">Blog</NuxtLink>
      <NuxtLink to="/trips" class="btn btn-ghost">Viajes</NuxtLink>
      <NuxtLink to="/trips/customize" class="btn btn-ghost"
        >Personalizar viaje</NuxtLink
      >
    </div>
  </nav>
</template>

<script setup>
const supabase = useSupabaseClient();
const user = useSupabaseUser();
const router = useRouter();

const logout = async () => {
  await supabase.auth.signOut();
  router.push("/login");
};
</script>
